<div class="header-area">
  <img [style]="'width:200px'" src="assets/images/header_ofi_copyright.png" />
  <div class="header-title">
      <label id="lblScreenTitle"></label>
  </div>
</div>
